import React from 'react';
import { Box, Button, TextField, Select, MenuItem, FormControl, Stack, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ShuffleIcon from '@mui/icons-material/Shuffle';
import { useNavigate } from "react-router-dom";
import { useCallback, useMemo, useState, useEffect } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import LockOpenIcon from '@mui/icons-material/LockOpen';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTranslation } from "react-i18next";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json'
import PER from '../../../utils/Enums.json'
import { styled } from "@mui/material";




export default function Editvendorpreqal({ Vendorid, org }) {

  const { t } = useTranslation();
  const navigate = useNavigate();

  const venid = Vendorid == null ? org : Vendorid 
  const handleAddNewClick = () => {
    // Redirect to "/ClientSelect" when the button is clicked

    const venid = Vendorid == null ? org : Vendorid
    navigate(
      "/ListOfPotentialClients?Vendor=" + venid)
  };
  const [error, setError] = useState(null);

  const [Preq, setPreq] = useState([]);
  const [index, setIndex] = React.useState(0);
  const [alignment, setAlignment] = React.useState("");
  const [intro, setIntro] = useState([]);
  const [id, setId] = React.useState('');
  const [selectedValue, setSelectedValue] = useState('');
  const [selectedValue1, setSelectedValue1] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(true);



  useEffect(() => {

    if (id) {
      axios.get("Prequalification/GetPQTemplates?PQID=" + id?.prequalificationId
      ).then((res) => {
        if (res.data.responseCode === 100) {
          const data = res?.data?.data;
          setIntro(data)
        }
        else {
          setError(res.data.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    }

  }, [id]);
  const handleClickOpen = (e) => {

    setOpen(true);
    setId(e);
    setSelectedValue(e.clientTemplateId)
    setSelectedValue1(e.clientTemplateId)
  };
  useEffect(() => {
    if (venid) {
      axios.get("Companies/GetPrequalificationsList?vendorId=" + venid
      ).then((res) => {
        if (res?.data?.responseCode === 100) {
          setPreq(res?.data?.data);
        }
        else {
          setError(res.data.responseMessage);
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        setIsLoading(false);
      });
    }
  }, [refresh]);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };


  const [SectionValue, setSectionValue] = useState('');
  const [email, setEmail] = useState('');
  const [registration, setRegistration] = useState('0');
  const [Body, setBody] = useState("");

  // const handleChange1 = (event) => {
  //   setSelectedValue(event.target.value);
  // };

  const handleChange1 = (event) => {

    if (event.target.value === selectedValue) {
    
    } else {
      setSelectedValue(event.target.value);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true)
    if (!selectedValue) {
      toast.error("Please fill all the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    }else if(selectedValue===selectedValue1){
      setIsLoading(false)
      toast.error("Please change template before submit", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {

      axios
        .post("Prequalification/ChangePQTemplate?pqId=" + id?.prequalificationId + "&templateId=" + selectedValue,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          if (res?.data?.responseCode == "100") {
            toast.success(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            handleClose();
            setRefresh(!refresh)

          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            // setOpen(false);
          }

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

  };
  const handleSubmit1 = (event) => {
    event.preventDefault();
    handlePopClose();

    setIsLoading(true)
    if (!selectedValue) {
      toast.error("Please fill all the mandatory fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

    } else {

      axios
        .post("Companies/UnlockPrequalification?pqId=" + id?.prequalificationId,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((res) => {
          if (res?.data?.responseCode == "100") {
            toast.success(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 4000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setRefresh(!refresh)

          } else {
            toast.error(res?.data?.responseMessage, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            // setOpen(false);
          }

        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

  };
  const [openpop, setOpenpop] = React.useState(false);
  const [unlock, setunlock] = React.useState(false);
  const [unlocked, setunlocked] = React.useState();
  const [EmpId, setEmpId] = React.useState();


  const handleClickOpenpop = (e) => {
    setEmpId(e)
    setOpenpop(true);
  };
  const handleClick = (e) => {
    setEmpId(e)
    setId(e);
    setunlock(true);
    setSelectedValue(e?.clientTemplateId);
  };

  const handlePopClose = () => {
    setOpenpop(false);
    setunlock(false);

  };
  const handleDelete = () => {
    handlePopClose();
    setIsLoading(true);
  
    setunlock(false);
    axios
      .post("Companies/DeletePrequalification?prequalificationId=" + EmpId?.prequalificationId,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseCode == "100") {

          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setRefresh(!refresh);
          setEmail("")

        } else {
          toast.error(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });

        }

      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });


  };
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ToastContainer />
      <Dialog
        open={openpop}
        keepMounted
        onClose={handlePopClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle> {"Are you sure? you want to permanently delete this content? This operation is irreversible."}</DialogTitle>
        <DialogContent>

        </DialogContent>
        <DialogActions>
          <Button onClick={handlePopClose}>{"Cancel"}</Button>
          <Button onClick={handleDelete}>{t('VendorDetails.label8')}</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogContent sx={{ padding: "" }} >
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <DialogTitle
            sx={{
              textAlign: "center",
              fontWeight: 500,
              fontSize: 20,
            }}
          >
            <p  >Safety Level</p>

          </DialogTitle>

          <DialogContentText sx={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: 18,
          }}>
            <p  >Note: Payment cannot be carried forward.</p>
          </DialogContentText>


          <div>
            <div className='mt-3' >
              <span style={{ color: "#3E4A62" }}>Template<span style={{ color: "red" }}>*</span></span>
              <br />
              <Select sx={{
                width: "100%", minWidth: "",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },

                fontFamily: "Arial, FontAwesome",
              }}

                size="small" value={selectedValue} onChange={handleChange1}>
                {intro?.item2?.map((option) => (
                  <MenuItem key={option.key} value={option.key}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>

            </div>
          </div >



        </DialogContent>

        {/* <DialogActions >
                    <div className="login-help__buttonContainer mt-4">
                      <Button variant="contained" className="login-help-button-cancel mx-2" onClick={handleClose}>Cancel</Button>
                      <Button variant="contained" className="login-button-request mx-2" onClick={handleSubmit}> Save</Button>
                    </div>

                  </DialogActions> */}
        <DialogActions style={{ justifyContent: 'center', marginBottom: "5px" }}>

          <Button
            variant="outlined"
            color="primary" // You can customize the color here
            style={{ backgroundColor: '#DBEAF4', padding: "20px", width: "170px" }}
            onClick={handleClose}
          >
            Cancel
          </Button>

          <Button
            style={{ backgroundColor: '#2A93DB', color: 'white', padding: "20px", width: "170px" }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </DialogActions>

      </Dialog>
      <Dialog
        open={unlock}
        onClose={handlePopClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >

        <DialogContent sx={{ padding: "48px 48px" }} >
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>


          <DialogContentText sx={{
            textAlign: "center",
            fontWeight: 500,
            fontSize: 18,
          }}>
            <p  >Are you sure you want to unlock this prequalification.</p>
          </DialogContentText>

        </DialogContent>

        <DialogActions >
          <div className="login-help__buttonContainer mx-5">
            <Button variant="contained" className="login-help-button-cancel " onClick={handlePopClose}>Cancel</Button>
            <Button variant="contained" className="login-button-request " onClick={handleSubmit1}>Submit</Button>
          </div>

        </DialogActions>

      </Dialog>
      <Box>
        <Box
          border={1}
          borderLeft={1}
          borderRight={1}
          borderColor="#e4e7ec"
          className="mt-2"
          sx={{ padding: "10px", background: "#fff", marginBottom: "10px" }}>
          <span style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500' }}>Existing Prequalifications
          </span>
          {HasPermissions(INFO?.ListOfPotentialClients?.actionName,PER?.ScreenPermissions.Read)&&  <Button variant="contained" sx={{ float: "right" }} onClick={handleAddNewClick}>
            <AddIcon /> Add New
          </Button>}
        
          <br />
          <hr />
          {Preq?.map((r) => (
            <Box key={r?.prequalificationId}>
              <p style={{ fontSize: "18px", color: "#3E4A62", fontWeight: '500' }}>{r?.clientName}- {r?.prequalificationStart && formatDate(r?.prequalificationStart)}
                <Stack direction={"row"} spacing={2} sx={{ float: "right" }} >
                  <LockOpenIcon hidden={r?.locked != true} onClick={() => handleClick(r)} />
                  <Tooltip title={"Unlocked by " + (r?.unlockedByFullName) + " on " + formatDate(r?.unlockedDate)} arrow hidden={r?.unlockedBy == null}>
                    <ErrorOutlineIcon hidden={r?.unlockedBy == null} />
                  </Tooltip>

                  <ShuffleIcon onClick={() => handleClickOpen(r)} />
                  <DeleteOutlineIcon onClick={() => handleClickOpenpop(r)} />
                </Stack>
              </p>
              <p className="mx-5" style={{ fontWeight: "bold" }}>{r?.comments}</p>

            </Box>
          ))}
        </Box>

      </Box>
    </>
  )
}
